import { render, staticRenderFns } from "./ItemsPerPageSelector.vue?vue&type=template&id=c79c0830&"
import script from "./ItemsPerPageSelector.vue?vue&type=script&lang=js&"
export * from "./ItemsPerPageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports